import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { iniciarConsentimiento } from './lib/cookieConsent'

// After each deploy the hashed chunk filenames change; browsers with the old
// index.html (open tabs, back-forward cache) fail to lazy-load pages with
// "Failed to fetch dynamically imported module". Reload once to pick up the
// new deploy. The timestamp guard avoids a reload loop if the chunk is
// genuinely missing (at most one reload every 10 seconds).
window.addEventListener('vite:preloadError', (event) => {
  const lastReload = Number(sessionStorage.getItem('chunk-reload-at') || 0)
  if (Date.now() - lastReload > 10_000) {
    event.preventDefault()
    sessionStorage.setItem('chunk-reload-at', String(Date.now()))
    window.location.reload()
  }
})

// Google Ads solo se carga si la persona ya aceptó las cookies (si no, espera al banner)
iniciarConsentimiento()

createRoot(document.getElementById("root")!).render(<App />);
